// extracted by mini-css-extract-plugin
export default {"btnContainer":"ConfirmShipment_btnContainer__f3lS9","link":"ConfirmShipment_link__FGJEn","dialog":"ConfirmShipment_dialog__LbGkn"};